module.exports = __webpack_public_path__ + "img/logo_merdeka.b384e238.png";